import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { OptionsData } from '../../../models/grid.model';


interface Props {
    MenuData: OptionsData[];
    OnClick: () => void;
}

export const MenuItemRenderer = (props: Props) => {
    return (
        <>
            {props.MenuData.map((option: OptionsData, index: number) => {
                const Icon = option.Icon;
                return !option.Hide &&
                    <MenuItem
                        key={`${option.Name}-${index}`}
                        onClick={() => { option.OnClick(); props.OnClick() }}
                        className={`${option.ClassName}`}
                    >
                        {option.Icon && <Icon className="mr-1 w-2" />}
                        <span className={"h5-regular color-grid-options"}>{option.Name}</span>
                    </MenuItem>
            }
            )}
        </>)
};
